import { contractTypes, jobStatus, jobTitles } from "@/services/job"
import { createObjectPagePathname } from "@/services/pathname"
import Link from "next/link"
import { regions } from "@/services/geography"
import moment from 'moment'
import { getName } from "@/services/aroeven"

type CardProps = {
    job: Job
}

export default function Card({
    job
}: CardProps) {
    return (
        <Link href={createObjectPagePathname('Job', job)} className="vignette -type-1 h-100">
            <div className="vignette__image">
                <div className="bandeau bienetre">
                    Offre d'emploi
                </div>
            </div>
            <div className="vignette__content pt-10">
                <div className="d-flex flex-column justify-content-between h-100">
                    <div>
                        {job.regions.length > 0 && <p className="text-light-1 lh-14 text-13 mt-5 mb-0">
                            <i className="fi fi-rr-marker text-primary-4" /> {job.regions.map(region => region in regions ? regions[region].name : null).filter(r => r).join(', ')}
                        </p>}
                        <h4 className="vignette__title py-10">{job.title}</h4>
                        {job.jobStatus in jobStatus &&
                            <div className="typeposte">
                                <i className={jobStatus[job.jobStatus].icon}></i> {jobStatus[job.jobStatus].name}
                            </div>
                        }
                        <div className="type">{contractTypes[job.contractType]?.name ?? 'Emploi'}</div>                        
                        {job.startDate && <div className="date">{!job.endDate && <>à partir </>}du {moment(job.startDate).format('DD/MM/YYYY')}{job.endDate && <> au {moment(job.endDate).format('DD/MM/YYYY')}</>}</div>}
                    </div>
                    <div>
                        <div className="organisation d-flex items-start">
                            <div className="flex-center size-20 rounded-full bg-primary-3 mr-5 text-white">
                                <i className="fi fi-rr-home" />
                            </div>
                            <div className="lh-1 mb-5">Proposé par {getName(job.proposedBy)}</div>
                        </div>
                    </div>
                </div>
            </div>
        </Link>
    )
}